<template>
	<div class="index">
		<headerview :cur="0"></headerview>

		<div class="content">

			<div class="moddlecon w13">
				<tipheader linTxt='THE HEADLINES' maxtitle="头条" mintitle="新闻" :ifimg="false" pathUrl="" :borderNo='false'></tipheader>
				<div class="newscon w12">
					<div class="newsrotate">
						<newsrotate></newsrotate>
					</div>
					<div class="newslist">
						<newslist></newslist>
					</div>
				</div>

				<div class="eventsbox">
					<themactlist></themactlist>
				</div>
				<!--最新通知 各地动态  -->
				<div class="listbox f-row-start-b wrap">
					<div class="w50">
						<domeList :borderNo='true' maxtitle="最新" mintitle="通知"  listUrl="/teaminform?type=2" pageSize='8' detailUrl='/textdetail?type=5' linTxt='LASTEST NOTICE'></domeList>
					</div>
					<div class="w50">
						<domeList :borderNo='true' maxtitle="各地" mintitle="动态"  listUrl="/teaminform?type=3" pageSize='8' detailUrl='/textdetail?type=6' linTxt='LOCAL DYNAMICS'></domeList>
					</div>
				</div>
				<!-- 学习资料 信息报送排行 -->
				<div class="listbox f-row-start-b wrap">
					<div class="w50">
						<domeList :borderNo='true' maxtitle="学习" mintitle="资料" listUrl="/learnmaterials" pageSize='8' detailUrl='/learnmaterials?type=1' linTxt='LEARNING MATERIALS'></domeList>
						<!-- <studylist></studylist> -->
					</div>
					<div class="w50">
						<domeList :borderNo='true' maxtitle="文件" mintitle="资料" listUrl="/filelibrary" pageSize='8' detailUrl='/textdetail?type=1' linTxt='FILE MATERIALS'></domeList>
<!--						<rankinglist></rankinglist>-->
					</div>
				</div>
				<div class="honorrollcon">
					<tipheader :maxtitle="'光荣'" :mintitle="'榜'"
					:ifimg="true" :sign="'1'" linTxt='THE HONOR ROLL'></tipheader>

					<div class="glorycon">
						<glorylist></glorylist>
					</div>
				</div>

				<div class="honorrollcon">
					<tipheader :maxtitle="'友情'" :mintitle="'链接'"
					:ifimg="false" linTxt='FRIENDSHIP LINK'></tipheader>

					<friendlink></friendlink>
				</div>

			</div>
		</div>

		<footview></footview>

	</div>

</template>

<script>
import domeList from '../../../com/domeList.vue'


import newslist from "../../../com/newslist.vue";
import newsrotate from "../../../com/newsrotate.vue";
import themactlist from "../../../com/themactlist-index.vue";
// import sociologylist from "../../../com/sociologylist.vue";
// import studylist from "../../../com/studylist.vue";
import glorylist from "../../../com/glorylist.vue";
import tipheader from "../../../com/tipheader.vue";
import friendlink from "../../../com/friendlink.vue";
// import rankinglist from "../../../com/rankinglist.vue";

export default {
  components: {
	 domeList,
  	 newslist,
	 newsrotate,
	 themactlist,
	//  sociologylist,
	//  studylist,
	 glorylist,
	 tipheader,
	 friendlink,
	 // rankinglist,
  },
  data: function() {
    return {


    };
  },

  mounted() {
		this.$onScrollT()
  },

  methods: {
  		tothemact(){
  			this.$router.push({ path: '/themactivities' });
  		},


  },


};
</script>

<style scoped=" scoped" lang="scss">
.content{
	display: flex;
	justify-content: center;
	.moddlecon{
		background-color: #FFFFFF;
		min-height: 1000px;
		padding: 20px 50px 0px 50px;
		.newscon{
			display: flex;
			flex-wrap: wrap;
			margin-top: 20px;
			.newsrotate{
				width: 670px;
				height: 440px;
			}
			.newslist{
				width: 504px;
				height: 440px;
				margin-left: 26px;
			}
		}

		.eventsbox{
			margin-top: 70px;
		}

		.listbox{
			margin-top: 60px;
			.w50{
				width: calc(50% - 40px);
			}
		}

		.honorrollcon{
			margin-top:40px;

		}

	}

}

</style>
